var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelPlanSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon",
    filter: "url(#filter0_d_1308_20300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1.5625,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#FFD6E4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7578 29.6057L29.4004 22.9631",
    stroke: "#EA1D63",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.3262 29.5212L22.6836 22.8787",
    stroke: "#EA1D63",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22 15.5635V18.5635",
    stroke: "#EA1D63",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M30 15.5635V18.5635",
    stroke: "#EA1D63",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.7495 17.1473C33.0895 17.2673 34.8395 18.3355 34.9395 23.0355V29.3136C34.9395 33.0636 34.2495 35.6255 29.4335 35.6255H23.1995C18.1995 35.7255 17.0796 33.4236 16.9996 29.3136L16.9395 23.3955C16.9995 18.8136 18.4995 17.1455 21.8095 17.1455L29.7495 17.1473Z",
    stroke: "#EA1D63",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1308_20300",
    x: 0,
    y: 0.5625,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1308_20300"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1308_20300",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelPlanSquare);
export default __webpack_public_path__ + "static/media/cancelPlanSquare.dc09131dca4ece5406303194fde439d3.svg";
export { ForwardRef as ReactComponent };